import { UserInfo } from "../models";

export const getUserInfo = (): UserInfo | null => {
  const userInfo = sessionStorage.getItem('userInfo');

  try {
    return userInfo ? JSON.parse(userInfo) as UserInfo : null;
  } catch (error) {
    console.error("Error al parsear userInfo desde sessionStorage:", error);
    return null;
  }
}
